import { forwardRef, type Ref, type SVGProps } from "react";
const IconDrawFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.699 8.01a1 1 0 0 0 0-1.43l-4.28-4.28a1 1 0 0 0-.71-.3 1.02 1.02 0 0 0-.72.3l-3.56 3.57 5.71 5.71Zm-.7 19.99h-1a2.84 2.84 0 0 1-1.615-.522 9.9 9.9 0 0 0 1.743-5.426 5.06 5.06 0 0 0-.669-2.7 2.913 2.913 0 0 0-4.918 0 5.06 5.06 0 0 0-.669 2.7 9.9 9.9 0 0 0 1.743 5.426 2.157 2.157 0 0 1-3.137-.358 4 4 0 0 1-.403-.657 5.5 5.5 0 0 0 .3-1.682c0-1.314-.74-1.781-1.375-1.781s-1.375.467-1.375 1.781a5.5 5.5 0 0 0 .3 1.683 4 4 0 0 1-.403.656 1.91 1.91 0 0 1-1.522.88h-6.29l15-14.99-5.71-5.71-15.99 15.98a1 1 0 0 0-.14.17c-.02.05-.05.11-.08.17a.6.6 0 0 0-.07.23l-.71 5a1.016 1.016 0 0 0 .982 1.146L3 30h12.999a3.84 3.84 0 0 0 3.002-1.528A3.82 3.82 0 0 0 21.999 30a4.83 4.83 0 0 0 3-1.053 4.83 4.83 0 0 0 3 1.053h1a1 1 0 0 0 0-2m-4-2.05a7.94 7.94 0 0 1-1.128-3.898 3.16 3.16 0 0 1 .358-1.63.913.913 0 0 1 1.54 0 3.16 3.16 0 0 1 .358 1.63 7.94 7.94 0 0 1-1.128 3.898"
    />
  </svg>
);
const ForwardRef = forwardRef(IconDrawFilledSVG);
ForwardRef.displayName = "IconDrawFilled";
export { ForwardRef as IconDrawFilled };
